"use strict";

exports.__esModule = true;

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Range = function () {
  function Range(start, end) {
    (0, _classCallCheck3.default)(this, Range);

    this.start = start;
    this.end = end;
  }

  Range.prototype.equals = function equals(other) {
    return other.start === this.start && other.end === this.end;
  };

  Range.prototype.copy = function copy() {
    return new Range(this.start, this.end);
  };

  Range.prototype.contains = function contains(index) {
    return index >= this.start && index <= this.end;
  };

  Range.prototype.extend = function extend(index) {
    this.start = Math.min(this.start, index);
    this.end = Math.max(this.end, index);
  };

  Range.merge = function merge(ranges) {
    ranges.sort(function (a, b) {
      return a.start - b.start;
    });

    var merged = [ranges[0]];

    for (var i = 1; i < ranges.length; i++) {
      var last = merged[merged.length - 1];
      var next = ranges[i];

      if (next.start <= last.end && next.end <= last.end) {
        // Ignore this range completely.
        // Next is contained inside last
        continue;
      } else if (next.start <= last.end) {
        last.end = next.end;
      } else {
        merged.push(next);
      }
    }

    return merged;
  };

  (0, _createClass3.default)(Range, [{
    key: "length",
    get: function get() {
      return this.end - this.start + 1;
    }
  }]);
  return Range;
}();

exports.default = Range;